import React from 'react';
import ReportAddDetailsRow from "./report-add-details-row";
import RedirectIfNotLogged from "../menu/redirect-if-not-logged";
import {SkyLightStateless} from 'react-skylight';
import Header from "../header";
import {styles} from "../menu/styles";
import * as ErrorAction from "../../redux/action/error-action";
import {connect} from "react-redux";
import * as ReportService from "../../services/report-service";
import {Constants} from "../../constants";
import request from "../../config/axios-config";
import * as validator from "../../general/validators/validator";
import * as ArticleDetailsState from "../../general/article-details-state";

class ReportsArticleDetailsDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            article: null,
            modalIsOpen: true,

            realPricePerUnit: '',
            realQuantity: '',
            budgetaryApprovedCredits: undefined,
            budgetaryCommitmentNumberDate: '',
            budgetaryCommitmentValueVat: undefined,
            acquisitionProcedure: "Directă",
            bidderCompanyName: "",
            bidEvaluationCriterion: "calitate/preț",
            bidValueNoVat: undefined,
            obtainedPoints: 30,
            winningBidPriceVat: undefined,
            numberLegalCommitment: undefined,
            billNrDate: "",
            paymentOpNrDate: "",
            paymentValue: undefined,
            leftLegalCommitmets: 0,
            receptionNrNote: "",
            receptionDate: "",

            //CPV stuff
            cpvSuggestionValue: "",
            cpvSuggestions: [],
            cpvSelectedValue: '',
            cpvSelectedName: '',
            cpvSelectedId: -1,

            //Loading stuff
            savingInProgress: false,
            savingSuccessful: false,
            savingError: false,

            //error handling
            error: {}
        };
    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
        });
        this.props.hideError();
        this.props.onCancel(this.state.shouldRefresh);
    };

    componentWillUnmount() {
        this.props.hideError();
    }

    componentDidMount() {
        let article = this.props.article;
        let articleDetails = this.props.article.articleDetails;

        let realPrice;
        if (articleDetails && articleDetails.realPricePerUnit) {
            realPrice = articleDetails.realPricePerUnit;
        } else {
            realPrice = article.pricePerUnit;
        }

        let realQuantity;
        if (articleDetails && articleDetails.realQuantity) {
            realQuantity = articleDetails.realQuantity;
        } else {
            realQuantity = article.quantity;
        }

        let realArticleName;
        if (articleDetails && articleDetails.realArticleName) {
            realArticleName = articleDetails.realArticleName;
        } else {
            realArticleName = article.product.name;
        }

        this.setState({
            article: article,
            cpvSelectedId: articleDetails && articleDetails.cpvCode && articleDetails.cpvCode.id,
            cpvSelectedCode: articleDetails && articleDetails.cpvCode && articleDetails.cpvCode.code,
            cpvSelectedName: articleDetails && articleDetails.cpvCode && articleDetails.cpvCode.name,
            cpvSelectedValue: articleDetails && articleDetails.cpvCode && (articleDetails.cpvCode.code + "-" + articleDetails.cpvCode.name),

            realArticleName: realArticleName,
            realPricePerUnit: realPrice,
            realQuantity: realQuantity,
            budgetaryApprovedCredits: articleDetails && articleDetails.budgetaryApprovedCredits,
            budgetaryCommitmentNumberDate: articleDetails && articleDetails.budgetaryCommitmentNumberDate,
            budgetaryCommitmentValueVat: articleDetails && articleDetails.budgetaryCommitmentValueVat,
            acquisitionProcedure: articleDetails ? articleDetails.acquisitionProcedure : "Directă",
            bidderCompanyName: articleDetails && articleDetails.bidderCompanyName,
            bidEvaluationCriterion: articleDetails ? articleDetails.bidEvaluationCriterion : "calitate/preț",
            bidValueNoVat: articleDetails && articleDetails.bidValueNoVat,
            obtainedPoints: articleDetails ? articleDetails.obtainedPoints : 30,
            winningBidPriceVat: articleDetails && articleDetails.winningBidPriceVat,
            numberLegalCommitment: articleDetails && articleDetails.numberLegalCommitment,
            billNrDate: articleDetails && articleDetails.billNrDate,
            paymentOpNrDate: articleDetails && articleDetails.paymentOpNrDate,
            paymentValue: articleDetails && articleDetails.paymentValue,
            leftLegalCommitmets: articleDetails && articleDetails.leftLegalCommitmets ? articleDetails.leftLegalCommitmets : 0,
            receptionNrNote: articleDetails && articleDetails.receptionNrNote,
            receptionDate: articleDetails && articleDetails.receptionDate ? new Date(articleDetails.receptionDate) : "",
        })
    }

    afterSavedSuccessful = (articleDetailsJson) => {
        let article = this.props.article;
        articleDetailsJson.article = null;
        articleDetailsJson.cpvCode = {};
        articleDetailsJson.cpvCode.id = articleDetailsJson.cpvCodeId;
        articleDetailsJson.cpvCode.code = articleDetailsJson.cpvSelectedCode;
        articleDetailsJson.cpvCode.name = articleDetailsJson.cpvSelectedName;
        articleDetailsJson.acquisitionState = ArticleDetailsState.getAcquisitionState(articleDetailsJson);
        articleDetailsJson.accountingState = ArticleDetailsState.getAccountingState(articleDetailsJson);
        articleDetailsJson.receptionState = ArticleDetailsState.getReceptionState(articleDetailsJson);


        article.articleDetails = articleDetailsJson;

        this.props.afterReportDetailsSaved();
    };

    onSaveClicked = () => {
        let article = this.props.article;
        let articleDetails = {
            id: article.articleDetails ? article.articleDetails.id : null,
            articleId: article.id,

            cpvCodeId: this.state.cpvSelectedId,
            cpvSelectedCode: this.state.cpvSelectedCode,
            cpvSelectedName: this.state.cpvSelectedName,
            cpvSelectedValue: this.state.cpvSelectedValue,

            realArticleName: this.state.realArticleName,
            realPricePerUnit: this.state.realPricePerUnit,
            realQuantity: this.state.realQuantity,
            budgetaryApprovedCredits: this.state.budgetaryApprovedCredits,
            budgetaryCommitmentNumberDate: this.state.budgetaryCommitmentNumberDate,
            budgetaryCommitmentValueVat: this.state.budgetaryCommitmentValueVat,
            acquisitionProcedure: this.state.acquisitionProcedure,
            bidderCompanyName: this.state.bidderCompanyName,
            bidEvaluationCriterion: this.state.bidEvaluationCriterion,
            bidValueNoVat: this.state.bidValueNoVat,
            obtainedPoints: this.state.obtainedPoints,
            winningBidPriceVat: this.state.winningBidPriceVat,
            numberLegalCommitment: this.state.numberLegalCommitment,
            billNrDate: !validator.isEmpty(this.state.billNrDate) ? this.state.billNrDate : null,
            paymentOpNrDate: this.state.paymentOpNrDate,
            paymentValue: this.state.paymentValue,
            leftLegalCommitmets: this.state.leftLegalCommitmets,
            receptionNrNote: this.state.receptionNrNote,
            receptionDate: this.state.receptionDate,
        };

        let error = {};
        let foundError = false;
        if (validator.isEmpty(this.state.cpvSelectedId)) {
            foundError = true;
            error.cpvSelectedValue = "Lipseste codul CPV";
        }
        if (validator.isEmpty(this.state.realPricePerUnit) || this.state.realPricePerUnit === 0) {
            foundError = true;
            error.realPricePerUnit = "Lipseste pretul sau este 0";
        }
        if (validator.isEmpty(this.state.realQuantity || this.state.realQuantity === 0)) {
            foundError = true;
            error.realQuantity = "Lipseste cantitatea sau este 0";
        }

        if(validator.isEmpty(this.state.realArticleName)) {
            foundError = true;
            error.realArticleName = "Lipseste denumirea";
        }

        if (foundError) {
            this.setState({
                error: error
            });
            return;
        } else {
            this.setState({
                error: {}
            })
        }

        this.setState({
            savingSuccessful: false,
            savingError: false,
            savingInProgress: true
        });
        this.props.hideError();

        ReportService.setDetails(articleDetails)
            .then(response => {
                this.setState({
                    savingInProgress: false,
                    savingSuccessful: true
                });
                this.afterSavedSuccessful(articleDetails);
            }).catch(err => {
            this.setState({
                savingSuccessful: false,
                savingError: true,
                savingInProgress: false
            });
            console.log("luci", JSON.stringify(err));
            this.props.showError("Salvarea a esuat! Va rog reincercati!");
        })
    };

    searchCpvCode = (value) => {
        if (validator.isEmpty(value)) {
            return;
        }

        request({
            url: Constants.SERVER_ENDPOINT + '/cpv/search?q=' + value,
            method: "GET",
        }).then(json => {
            if (json.data.length > 0) {
                this.setState({
                    cpvSuggestions: json.data.map((t, i) => {
                        return (
                            {
                                value: t.id,
                                text: t.code + " - " + t.name,
                                name: t.name,
                                code: t.code,
                            }
                        )
                    }),
                });
            }
        }).catch(ignore => {

        })
    };

    onChangeCpvSuggestion = (newValue) => {
        this.searchCpvCode(newValue);
        this.setState({
            cpvSuggestionValue: newValue
        });
    };

    onCpvSuggestionsClearRequested = (chosenRequest, index) => {
        let selectedCpvCode = this.state.cpvSuggestions[index];
        this.setState({
            cpvSelectedId: selectedCpvCode.value,
            cpvSelectedValue: selectedCpvCode.text,
            cpvSelectedName: selectedCpvCode.name,
            cpvSelectedCode: selectedCpvCode.code,
            cpvSuggestionValue: '',
            cpvSuggestions: [],
        });
    };


    render() {

        let articleCode;
        if (this.props.article.paper) {
            articleCode = this.props.article.paper.yearId + "/" + this.props.article.paper.createdYear + "/" + this.props.article.orderId;
        } else {
            articleCode = "";
        }

        return (
            <div>
                <RedirectIfNotLogged/>

                <SkyLightStateless
                    isVisible={this.state.modalIsOpen}
                    dialogStyles={styles.defaultDialogStyles}
                    onCloseClicked={this.closeModal}
                    onOverlayClicked={this.closeModal}
                    title={<Header title={this.props.title}/>}
                >
                    <div>
                        <ReportAddDetailsRow
                            canUserSeeAllReports={this.props.canUserSeeAllReports}
                            canUserEditAcquisitionsReports={this.props.canUserEditAcquisitionsReports}
                            canUserEditAccountingReports={this.props.canUserEditAccountingReports}
                            canUserEditReceptionReports={this.props.canUserEditReceptionReports}

                            error={this.state.error}

                            savingInProgress={this.state.savingInProgress}
                            savingSuccessful={this.state.savingSuccessful}
                            savingError={this.state.savingError}


                            articleCode={articleCode}
                            articleDetails={this.props.article.details ? this.props.article.details : ""}
                            vat={this.props.article.vat}
                            estimatedValueNoVat={(this.state.realPricePerUnit * this.state.realQuantity).toFixed(2)}

                            cpvCode={this.state.cpvCode}
                            cpvSuggestionValue={this.state.cpvSuggestionValue}
                            cpvSuggestions={this.state.cpvSuggestions}
                            cpvSelectedValue={this.state.cpvSelectedValue}
                            onChangeCpvSuggestion={this.onChangeCpvSuggestion}
                            onCpvSuggestionsClearRequested={this.onCpvSuggestionsClearRequested}

                            realArticleName={this.state.realArticleName}
                            realPricePerUnit={this.state.realPricePerUnit}
                            realQuantity={this.state.realQuantity}
                            budgetaryApprovedCredits={this.state.budgetaryApprovedCredits}
                            budgetaryCommitmentNumberDate={this.state.budgetaryCommitmentNumberDate}
                            budgetaryCommitmentValueVat={this.state.budgetaryCommitmentValueVat}
                            acquisitionProcedure={this.state.acquisitionProcedure}
                            bidderCompanyName={this.state.bidderCompanyName}
                            bidEvaluationCriterion={this.state.bidEvaluationCriterion}
                            bidValueNoVat={this.state.bidValueNoVat}
                            obtainedPoints={this.state.obtainedPoints}
                            winningBidPriceVat={this.state.winningBidPriceVat}
                            numberLegalCommitment={this.state.numberLegalCommitment}
                            billNrDate={this.state.billNrDate}
                            paymentOpNrDate={this.state.paymentOpNrDate}
                            paymentValue={this.state.paymentValue}
                            leftLegalCommitmets={this.state.leftLegalCommitmets}
                            receptionNrNote={this.state.receptionNrNote}
                            receptionDate={this.state.receptionDate}

                            onRealArticleNameChange={e => this.setState({realArticleName: e.target.value})}
                            onRealPricePerUnitChange={e => this.setState({realPricePerUnit: e.target.value})}
                            onRealQuantityChange={e => this.setState({realQuantity: e.target.value})}
                            onBudgetaryApprovedCreditsChange={(e) => this.setState({budgetaryApprovedCredits: e.target.value})}
                            onBudgetaryCommitmentNumberChange={(e) => this.setState({budgetaryCommitmentNumberDate: e.target.value})}
                            onBugdetaryCommitmentValueVatChange={(e) => this.setState({budgetaryCommitmentValueVat: e.target.value})}
                            onAcquisitionProcedureChange={(e) => this.setState({acquisitionProcedure: e.target.value})}
                            onBidderCompanyNameChange={(e) => this.setState({bidderCompanyName: e.target.value})}
                            onBidEvaluationCriterionChange={(e) => this.setState({bidEvaluationCriterion: e.target.value})}
                            onBidValueNoVatChange={(e) => this.setState({bidValueNoVat: e.target.value})}
                            onObtainedPointsChange={(e) => this.setState({obtainedPoints: e.target.value})}
                            onWinningBidPriceVatChange={(e) => this.setState({winningBidPriceVat: e.target.value})}
                            onValueLegalCommitmentVatChange={(e) => this.setState({numberLegalCommitment: e.target.value})}
                            onBillNrDateChange={(e) => this.setState({billNrDate: e.target.value})}
                            onPaymentOpNrDateChange={(e) => this.setState({paymentOpNrDate: e.target.value})}
                            onPaymentValueChange={(e) => this.setState({paymentValue: e.target.value})}
                            onLeftLegalCommitmetsChange={(e) => this.setState({leftLegalCommitmets: e.target.value})}
                            onReceptionNrNoteChange={(e) => this.setState({receptionNrNote: e.target.value})}
                            onReceptionDateChange={(event, date) => {
                                this.setState({receptionDate: date});
                            }}
                            onSaveClicked={this.onSaveClicked}
                        />

                    </div>
                </SkyLightStateless>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        canUserSeeAllReports: state.login.user.canSeeAllReports,
        canUserEditAcquisitionsReports: state.login.user.canEditAcquisitionsReports,
        canUserEditAccountingReports: state.login.user.canEditAccountingReports,
        canUserEditReceptionReports: state.login.user.canEditReceptionReports,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (text) => dispatch(ErrorAction.showError(text)),
        hideError: () => dispatch(ErrorAction.hideError())
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportsArticleDetailsDialog)